<template>
  <section class="bottom">
    <ModuleSection
      :id="`_${$options.name}`"
      title="Grußnachricht"
      icon='<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M7.875 7.875L7.875 7.875" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.25,8.25a.375.375,0,0,0-.375-.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M7.875,7.875a.375.375,0,1,0,.375.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12.375 7.875L12.375 7.875" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12.375,7.875a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M4.500 20.625 A1.875 1.875 0 1 0 8.250 20.625 A1.875 1.875 0 1 0 4.500 20.625 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M1.125 22.5L1.125 22.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M1.125,22.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M16.875 7.875L16.875 7.875" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.25,8.25a.375.375,0,0,0-.375-.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M16.5,8.25a.375.375,0,0,0,.75,0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M16.875,7.875a.375.375,0,0,0-.375.375" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M3.786,6.365A3.667,3.667,0,0,1,3.75,6a3.746,3.746,0,0,1,6.368-2.679A7.493,7.493,0,1,1,15.75,15.75H5.625A4.872,4.872,0,0,1,3.786,6.365Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>'
    >
      <div :class="`grid-${$store.getters.isB2b ? '1' : '2'}_xs-1-spaceBetween-equalHeight u-grid-small-gutter u-mb-2`">
        <div class="col">
          <FancyChooser
            @click="$root.$emit('composerModal:open', 'ModalPostcardMessageHandwritten')"
            :isSelected="selectionData.mode == 1"
            :isDisabled="$store.getters.getSelectedQty < $store.getters.getOrderQtySize.sm.min ? false : true"
            :maxQuantity="$store.getters.getOrderQtySize.sm.min"
          >
            <template v-slot:title>Handgeschrieben</template>
            <template
              v-if="selectionData.mode == 1"
              v-slot:description
            >
              <slot v-if="selectionData.option === 1">
                „{{ selectionData.text.substring(0, 100) }}<slot v-if="selectionData.text.length > 100">…</slot>”
              </slot>

              <slot v-if="selectionData.option === 2">
                Gleicher Text für alle {{ $store.getters.getSelectedQty }} Präsente, mit persönlicher Anrede
              </slot>

              <slot v-if="selectionData.option === 3">
                Unterschiedliche Texte
              </slot>

              <br>

              <a>Bearbeiten</a>
            </template>
            <template
              v-else
              v-slot:description
            >
              <slot v-if="$store.getters.isB2b">
                160 Zeichen ohne Aufpreis, je weitere 160 Zeichen +2,00 EUR, max. 480 Zeichen möglich
              </slot>

              <slot v-else>
                inkl. 160 Zeichen ohne Aufpreis — Mehr Zeichen möglich
              </slot>
            </template>
            <template v-slot:icon>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><g><path d="M13.68,23.25H1.82A1.07,1.07,0,0,1,.75,22.17V1.83A1.07,1.07,0,0,1,1.82.75h15.1A1.08,1.08,0,0,1,18,1.83V7.21" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><line x1="7.2" y1="6.38" x2="13.66" y2="6.38" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><path d="M3.8,6a.38.38,0,1,1,0,.75A.38.38,0,0,1,3.8,6" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M3.8,9.86a.38.38,0,1,1,0,.75.38.38,0,0,1,0-.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M15.93,11.35a11.92,11.92,0,0,0-1.69-.9,2.09,2.09,0,0,0-2.13.17l-1.85,1.32A2.59,2.59,0,0,0,9.2,13.69l-.28,2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><line x1="23.25" y1="22.5" x2="17.89" y2="13.94" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><path d="M13.71,16.5l5.57-3.41a1.62,1.62,0,0,0-1.69-2.76L7.5,16.52h0L5.59,19.58l3.59-.31h0L11.25,18" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M16.5,16.5H12.75a1.5,1.5,0,0,0-1.5,1.5h0a1.5,1.5,0,0,0,1.5,1.5h2.74l1.76,3.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g></g></svg>
            </template>
          </FancyChooser>
        </div>

        <div
          v-if="$store.getters.isB2b"
          class="col"
        >
          <FancyChooser
            @click="$root.$emit('composerModal:open', 'ModalPostcardMessagePrinted')"
            :isSelected="selectionData.mode == 2"
            :isDisabled="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min ? false : true"
            :minQuantity="$store.getters.getOrderQtySize.sm.min"
          >
            <template v-slot:title>Gedruckt</template>
            <template
              v-if="selectionData.mode == 2"
              v-slot:description
            >
              „{{ selectionData.text.substring(0, 100) }}<slot v-if="selectionData.text.length > 100">…</slot>”

              <br>

              <a>Bearbeiten</a>
            </template>
            <template
              v-else
              v-slot:description
            >
              max. 1200 Zeichen, ohne Aufpreis
            </template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M5.25,17.249h-3a1.5,1.5,0,0,1-1.5-1.5v-7.5a1.5,1.5,0,0,1,1.5-1.5h19.5a1.5,1.5,0,0,1,1.5,1.5v7.5a1.5,1.5,0,0,1-1.5,1.5h-3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M3.75 9.749L5.25 9.749" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 12.749H18.75V23.249000000000002H5.25z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M18.75,6.749H5.25v-4.5a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,0,1,1.5,1.5Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.25 15.749L15.75 15.749" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.25 18.749L13.5 18.749" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
            </template>
          </FancyChooser>
        </div>

        <div class="col">
          <FancyChooser
            @click="selectionData.mode = 3"
            :isSelected="selectionData.mode == 3"
          >
            <template v-slot:title>Ohne Grußtext</template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M4.045 19.955L19.955 4.045" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
            </template>
          </FancyChooser>
        </div>

        <div
          v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.sm.min"
          class="col"
        >
          <FancyChooser
            @click="selectionData.mode = 4"
            :isSelected="selectionData.mode == 4"
          >
            <template v-slot:title>Später festlegen</template>
            <template v-slot:icon>
              <svg viewBox="0 0 32 32" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.75 14.25L0.75 23.25" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6 18.75L9 18.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M7.684,12.816A8.25,8.25,0,1,1,17.021,17" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M14.25 3.75L14.25 9.75 18 9.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
            </template>
          </FancyChooser>
        </div>
      </div>

      <div
        v-if="boxQty === 1 && (selectionData.mode == 1 || selectionData.mode == 2) && ($store.getters.getSelectedItem.data !== null && msgTemplates.length > 0)"
        class="grid-2_xs-1-spaceBetween-equalHeight u-grid-small-gutter u-mb-2"
      >
        <div class="col" v-for="(template, index) in msgTemplates" :key="index">
          <FancyChooser
            @click="validateText = template.default_text"
          >
            <template v-slot:title>{{ template.name }}</template>
            <template v-slot:description>Text übernehmen</template>
            <template v-slot:icon></template>
          </FancyChooser>
        </div>
      </div>

      <Notice
          v-if="selectionData.mode == 3"
        >
        <p>Diese Option bietet sich beispielsweise an, wenn Sie die die Grußkarten selber beschreiben oder bedrucken möchten.</p>
      </Notice>

      <Notice
        v-if="selectionData.mode == 4"
      >
        <p>Sie werden nach der Bestellung aufgefordert, die Daten für diese Option anzugeben.</p>
      </Notice>
    </ModuleSection>
  </section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';
import { logicMixin } from '@/mixins/LogicMixin';

import ModuleSection from '@/components/Composer/ModuleSection';
import FancyChooser from '@/components/Composer/FancyChooser';
import Notice from '@/components/Composer/Notice';

export default {
  name: 'ModulePostcardMessage',
  props: ['selectionData'],
  mixins: [UiMixin, logicMixin],
  components: {
    ModuleSection,
    FancyChooser,
    Notice,
  },
  mounted () {
    this.$root.$on('changedQty', (value) => {
      if (parseInt(value) === 1) {
        this.selectionData.option = 1;
      } else if (parseInt(value) > 1) {
        this.selectionData.option = this.$store.getters.getUserGroupId === '14017' ? 3 : 1;
      }
    });
  },
  computed: {
    msgTemplates() {
      const templates = [];
      if (this.$store.getters.getMsgSettings[this.$store.getters.getUserGroupId]) {
        this.$store.getters.getMsgSettings[this.$store.getters.getUserGroupId].messages.forEach(m => {
          if (m.lvl1_boxes !== false && m.lvl1_boxes.includes(this.$store.getters.getSelectedItem.data.id)) {
            templates.push(m);
          }
        });
      }
      return templates;
    }
  },
  watch: {
    'selectionData.mode': {
      handler: function (newVal) {
        if (newVal === 1 && this.selectionData.text.length > 480) {
          this.selectionData.text = this.selectionData.text.substr(0, 480);
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Postcard Message
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard's message options
 * @since 2021-08-31
**/

$component: 'message';

.#{$component} {
  &__chars {
    @include margin-top(- map-get($spacers, 2));
    @include margin-bottom($spacer);
    color: $ink-lighter;
    @include font-size($font-size-sm);

    > p {
      margin: 0;
    }
  }

  &__bar {
    width: 100%;
    @include margin-top(map-get($spacers, 2));
    border-radius: $border-radius-lg;
    background-color: $sky;
  }

  &__progress {
    display: block;
    min-width: 0.2px;
    height: 0.3rem;
    border-radius: $border-radius-lg;
    background-color: $primary;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
